export const refreshFABVisibility = () => {
    const fab = document.getElementById('fabToday');
    const target = document.querySelector('.last-activated');
    
    if (!fab) return;

    if (!target) {
        // If no target element found, hide and return
        fab.classList.add('fab-hidden');
        return false;
    }
    fab.classList.remove('fab-hidden');
    return true;
};

export const initFAB = () => {
    const fab = document.getElementById('fabToday');
    if (!fab) return;

    let lastScrollY = window.scrollY;

    // Run initial check
    refreshFABVisibility();

    window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        
        // First check if the target element exists
        if (!refreshFABVisibility()) return;

        // Scroll direction logic
        if (currentScrollY > lastScrollY && currentScrollY > 100) {
            fab.classList.add('fab-hidden');
        } else {
            fab.classList.remove('fab-hidden');
        }

        lastScrollY = currentScrollY;
    });

    fab.addEventListener('click', () => {
        const targetElement = document.querySelector('.last-activated');
        
        if (targetElement) {
            fab.classList.add('fab-hidden');

            targetElement.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'center' 
            });

            // Visual feedback
            targetElement.style.transition = 'background-color 0.5s';
            targetElement.style.backgroundColor = 'rgba(25, 135, 84, 0.1)';
            setTimeout(() => targetElement.style.backgroundColor = '', 2000);
        }
    });
};